import { apiService } from './api';

export interface AqiStandard {
  id: number;
  standardName: string;
  description: string;
}

export interface ParametersWithPreferredUnit {
  parameterId: number;
  parameterName: string;
  preferredUnitName: string;
}

export interface updateParameterUnitsPreferencesRequest {
  parameters: ParametersWithPreferredUnit[];
}

// export interface ParameterInterface {
//   parameterId: number;
//   parameterName: string;
//   preferredUnitId: number | null;
//   preferredUnitName: string | null;
//   primaryUnitId: number | null;
//   primaryUnitName: string | null;
// }

export interface AccountPreferencesResponse {
  aqiStandardId: number;
  aqiStandardName: string;
  timezone: string;
  parametersWithPreferredUnit: ParametersWithPreferredUnit[] | null;
}

export const aqiStandardApi = {
  getAqiStandards: async (): Promise<AqiStandard[]> => {
    const response = await apiService.request<AqiStandard[]>('/AqiStandard');
    if (!response.success || !response.data) {
      throw new Error(response.error || 'Failed to fetch AQI standards');
    }
    return response.data;
  },
  
  // Get user account preferences (AQI standard, timezone, and parameter units)
  getUserAccountPreferences: async (): Promise<AccountPreferencesResponse | null> => {
    const response = await apiService.request<AccountPreferencesResponse>('/Account/account-preferences');
    if (!response.success) return null;
    return response.data || null;
  },
  
  // Update user account preferences (AQI standard, timezone, and parameter units)
  updateUserParameterUnitsPreferences: async (preferences: updateParameterUnitsPreferencesRequest): Promise<boolean> => {
    const response = await apiService.request<{ message: string }>('/Account/parameter-units-preferences', {
      method: 'PUT',
      body: JSON.stringify(preferences),
    });
    return !!response.success;
  },

  updateUserAqiStandardandTimezone: async (aqiStandardId: number, timezone: string): Promise<boolean> => {
    const response = await apiService.request<{ message: string }>('/Account/aqi-standard-and-timezone', {
      method: 'PUT',
      body: JSON.stringify({ aqiStandardId, timezone }),
    });
    return !!response.success;
  },
};

export default aqiStandardApi;

